module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_home2.e56a3.png";